export default {
  banners: []
}
